// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"565":"aeb4a5a6","1371":"b713f104","7052":"ce4d6ea5","8111":"96a15e75"}[chunkId] + ".chunk.css";
};